export interface SkillDigestDisplaySource {
  readonly content_digest?: string | null;
  readonly digest?: string | null;
  readonly content_digest_algorithm?: string | null;
  readonly digest_algorithm?: string | null;
}

export function skillDigestValue(skill: SkillDigestDisplaySource): string {
  return skill.content_digest || skill.digest || '';
}

export function skillDigestAlgorithm(skill: SkillDigestDisplaySource): string {
  return skill.content_digest_algorithm || skill.digest_algorithm || 'sha256';
}

export function fullSkillDigest(skill: SkillDigestDisplaySource): string {
  const digest = skillDigestValue(skill);
  if (!digest) return '';
  return skillDigestAlgorithm(skill) + ':' + digest;
}

export function shortSkillDigest(skill: SkillDigestDisplaySource, length = 12): string {
  const digest = skillDigestValue(skill);
  if (!digest) return 'N/A';
  return skillDigestAlgorithm(skill) + ':' + digest.slice(0, length);
}
